import { IconButton } from '../pressables';
import styles from './Toast.module.scss';

interface Props {
  message: string;
  onDismiss: () => void;
}

export function Toast({ message, onDismiss }: Props) {
  return (
    <div className={styles['toast']} role="status">
      <span className={styles['toast-message']}>{message}</span>
      <IconButton
        aria-label="Cerrar"
        onClick={onDismiss}
        size="small"
        variant="clear"
      >
        ×
      </IconButton>
    </div>
  );
}
